import { Routes } from '@angular/router';
import { viewAccessGuard } from './core/guards/view-access.guard';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';
import { companySelectedGuard } from './core/guards/company-selected.guard';
export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((m) => m.LoginComponent),
    title: 'Login - SJ Jewels',
    canActivate: [guestGuard],
  },
  {
    path: '',
    loadComponent: () =>
      import('./layout/layout.component').then((m) => m.LayoutComponent),
    data: { breadcrumb: 'Dashboard' },
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        path: 'dashboard',
        data: { preload: true, preloadDelayMs: 800 },
        loadComponent: () =>
          import('./dashboard/dashboard.component').then(
            (m) => m.DashboardComponent,
          ),
        title: 'Dashboard - SJ Jewels',
      },
      {
        path: 'users',
        data: { breadcrumb: 'Users' },
        canActivate: [viewAccessGuard],
        loadChildren: () =>
          import('./users/users.routes').then((m) => m.USERS_ROUTES),
      },
      {
        path: 'access-rights',
        data: { breadcrumb: 'Access Rights' },
        canActivate: [viewAccessGuard],
        loadChildren: () =>
          import('./access-right/access-right.routes').then(
            (m) => m.ACCESS_RIGHT_ROUTES,
          ),
      },
      {
        path: 'module-management',
        data: { breadcrumb: 'Module Management' },
        canActivate: [viewAccessGuard],
        loadChildren: () =>
          import('./module-management/module-management.routes').then(
            (m) => m.MODULE_MANAGEMENT_ROUTES,
          ),
      },
      {
        path: 'company-details',
        data: { breadcrumb: 'Company Details', preload: true },
        canActivate: [viewAccessGuard],
        loadChildren: () =>
          import('./company-details/company-details.routes').then(
            (m) => m.COMPANY_DETAILS_ROUTES,
          ),
      },
      // Solvix Salesmen / Purity masters retired from UI — use Accounts masters instead.
      // {
      //   path: 'salesmen',
      //   data: { breadcrumb: 'Salesmen', preload: true },
      //   canActivate: [viewAccessGuard],
      //   loadChildren: () =>
      //     import('./salesmen/salesmen.routes').then(
      //       (m) => m.SALESMEN_ROUTES,
      //     ),
      // },
      // {
      //   path: 'purities',
      //   data: { breadcrumb: 'Purity', preload: true },
      //   canActivate: [viewAccessGuard],
      //   loadChildren: () =>
      //     import('./purities/purities.routes').then(
      //       (m) => m.PURITIES_ROUTES,
      //     ),
      // },
      {
        path: 'daily-metal-rates',
        data: { breadcrumb: 'Daily Metal Rates', preload: true },
        loadChildren: () =>
          import('./daily-metal-rates/daily-metal-rates.routes').then(
            (m) => m.DAILY_METAL_RATES_ROUTES,
          ),
      },
      {
        path: 'audit-logs',
        data: { breadcrumb: 'User Audit Logs' },
        canActivate: [viewAccessGuard],
        loadChildren: () =>
          import('./audit-logs/audit-logs.routes').then(
            (m) => m.AUDIT_LOGS_ROUTES,
          ),
      },
      {
        path: 'item-wise-profit-loss',
        data: { breadcrumb: 'Item-wise Profit & Loss' },
        canActivate: [viewAccessGuard, companySelectedGuard],
        loadChildren: () =>
          import('./item-wise-profit-loss/item-wise-profit-loss.routes').then(
            (m) => m.ITEM_WISE_PROFIT_LOSS_ROUTES,
          ),
      },
      {
        path: 'stock-report',
        data: { breadcrumb: 'Stock Movement Report' },
        canActivate: [viewAccessGuard, companySelectedGuard],
        loadChildren: () =>
          import('./stock-report/stock-report.routes').then((m) => m.STOCK_REPORT_ROUTES),
      },
      {
        path: 'label-generation',
        data: { breadcrumb: 'Label Generation', preload: true, preloadDelayMs: 1000 },
        canActivate: [viewAccessGuard],
        loadChildren: () =>
          import('./label-generation/label-generation.routes').then(
            (m) => m.LABEL_GENERATION_ROUTES,
          ),
      },
      {
        path: 'accounting',
        data: { breadcrumb: 'Accounting' },
        canActivate: [viewAccessGuard, companySelectedGuard],
        loadChildren: () =>
          import('./accounting/accounting.routes').then((m) => m.ACCOUNTING_ROUTES),
      },
    ],
  },
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: '**', redirectTo: 'login' },
];
